import { format } from "date-fns";
import { Box, Button, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import usePersonStore from "../../../../../store/personStore";
import { Note } from "@mui/icons-material";
import { useStudentContext } from "../../../../../../context/studentContext";
import { StudentDataType } from "../../../../../StudentPages/hooks/useSelectedStudent";
import { useSelectedStudent } from "../../../../../StudentPages/hooks";

export interface LinkItemsHeaderProps {
  entityId: string,
  startDate: Date,
  endDate?: Date | null,
  expired?: boolean | null,
  consentStatus?: string | null,
  onExpire?: (id: string) => void
  goToNotes?: (student: StudentDataType) => void
}

export default function LinkItemsHeader({ entityId, startDate, endDate, expired = false, consentStatus, goToNotes, onExpire }: LinkItemsHeaderProps) {
  const myId = usePersonStore(state => state.id);
  const isItMe = entityId === myId;
  const companyConsentPolicy = usePersonStore(state => state.company.consentPolicy)
  const onPersonManagePage = window.location.pathname.includes("user")
  // const { studentData } = useStudentContext()
  const { student } = useSelectedStudent()
  const spaceAtCaps = (parentalConsentStatus: string | undefined | null) => {
    return parentalConsentStatus?.replace(/([A-Z])/g, " $1").trim();
  }
  return (
    <Grid container
      style={{
        paddingTop: 16,
      }}
    >
      <Grid size={12}>
        <Box
          component="div"
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid container>
            <Grid size={10}>
              <Box component={"div"} style={{ display: "flex", justifyContent: "space-evenly" }}>
                {(companyConsentPolicy && !onPersonManagePage) ?
                  <Box component={"div"} style={{ marginRight: 32, }}>
                    <Typography color="secondary" sx={{ fontSize: "14px" }}>
                      Parental Consent
                    </Typography>
                    <Typography sx={{ fontSize: "18px" }}>
                      {consentStatus ? spaceAtCaps(consentStatus) : "Not Requested"}
                    </Typography>
                  </Box> : <></>}

                <Box component={"div"} style={{ marginRight: 32, }}>
                  <Typography color="secondary" sx={{ fontSize: "14px" }}>
                    Start Date
                  </Typography>
                  <Typography sx={{ fontSize: "18px" }}>
                    {startDate
                      ? format(new Date(startDate), "MM/dd/yyyy")
                      : "n/a"}
                  </Typography>
                </Box>
                <Box component={"div"} style={{ marginRight: 32, }}>
                  <Typography color="secondary" sx={{ fontSize: "14px" }}>
                    End Date
                  </Typography>
                  <Typography sx={{ fontSize: "18px" }}>
                    {endDate
                      ? format(new Date(endDate), "MM/dd/yyyy")
                      : "n/a"}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid size={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Tooltip title={isItMe ? "Cannot Expire Self" : ""}>
                <div>
                  <Button disabled={isItMe}
                    sx={{ color: expired ? 'primary' : "#8E1C3B" }}
                    onClick={() => onExpire && onExpire(entityId ?? '')}
                    startIcon={
                      expired
                        ? (
                          <CheckCircleIcon />
                        )
                        : (

                          <CloseIcon
                            style={{
                              backgroundColor: "#8E1C3B",
                              borderRadius: "100%",
                              color: "white",
                            }}
                          />
                        )
                    }
                  >
                    {expired ? "Reactivate User" : "Expire User"}
                  </Button>
                </div>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      </Grid >
    </Grid >
  );
}